// Put your application javascript here
    // 产品滑块功能
    $('.main-carousel').flickity({
        // options
        cellAlign: 'center',
        contain: true,
        watchCSS: true,
        prevNextButtons: false,
        pageDots: false
    });
    // Plans滑块功能
    $('.plans-carousel').flickity({
        // options
        cellAlign: 'center',
        contain: true,
        adaptiveHeight: true,
        watchCSS: true,
        prevNextButtons: false,
        pageDots: false
    });
    // 搜索页面框
    $('.div-block-49').each(function() {
        const $group = $(this);
        const $input = $group.find('.text-field-3.w-input');
        const $btn = $group.find('.div-block-50');
      
        $btn.toggle($input.val().length > 0);
        
        $input.on('input', () => {
          $btn.toggle($input.val().length > 0);
        });
      
        $btn.on('click', () => {
          $input.val('').trigger('input');
        });
      });

  // 首页搜索
   // 为所有包含 actionBtn 类的按钮绑定点击事件
    $('.div-block-88').on('click', function() {
      // 1. 获取按钮文本并去除首尾空格
      const buttonText = $(this).text().trim();
      
      // 2. 将文本填入搜索框
      $('#searchInput').val(buttonText);
      
      // 3. 提交表单
      $('#email-search').submit();
    });

  //详情页页面增减按钮
    // 减号按钮点击
    $('.p-qty-minus').click(function() {
        const $input = $(this).siblings('.p-qty-input');
        let value = parseInt($input.val()) || 1;
        
        if (value > 1) {
        value--;
        $input.val(value);
        updateButtonState($input);
        }
    });

    // 加号按钮点击
    $('.p-qty-plus').click(function() {
        const $input = $(this).siblings('.p-qty-input');
        let value = parseInt($input.val()) || 0;
        value++;
        $input.val(value);
        updateButtonState($input);
    });

    // 输入框内容变化验证
    $('.p-qty-input').on('input', function() {
        let value = parseInt($(this).val()) || 1;
        if (value < 1) value = 1;
        $(this).val(value);
        updateButtonState($(this));
    });

  // 初始化按钮状态
  updateButtonState($('.p-qty-input'));

  // 更新按钮禁用状态
  function updateButtonState($input) {
    const value = parseInt($input.val()) || 1;
    $input.siblings('.p-qty-minus').prop('disabled', value <= 1);
  }


  // 监听 input 事件
  $('#simid').on('input', function() {
    // 获取填入data-simid 的值
   $(this).attr('data-simid',$('#simid').val());;
  });

  // gsap动画

  const $content = $('.div-block-118');
  const $button = $('.div-block-54');
  let isExpanded = false; // 状态标记

  // 点击按钮事件
  $button.on('click', function() {
    if (isExpanded) {
      // 收缩动画
      gsap.to($content, {
        height: 0,
        opacity: 0,
        display: "none",
        duration: 0.3,
        ease: "power2.inOut"
      });
    } else {
      // 展开动画
      gsap.to($content, {
        display: "flex",
        height: 'auto', // 自动计算实际高度
        opacity: 1,
        duration: 0.3,
        ease: "power2.inOut"
      });
    }
    isExpanded = !isExpanded; // 切换状态
  });

  // 商品详情页
  
  $(".div-block-77").click(function(){
      let isExpanded = $(this).attr("data-expanded");
      let chlidcontent = $(this).find(".div-block-120");
      if (isExpanded == "true") {
          // 收缩动画
          gsap.to(chlidcontent, {
            height: 0,
            opacity: 0,
            display: "none",
            duration: 0.3,
            ease: "power2.inOut"
          });
          $(this).attr("data-expanded",false)
        } else {
          // 展开动画
          gsap.to(chlidcontent, {
            display: "flex",
            height: 'auto', // 自动计算实际高度
            opacity: 1,
            duration: 0.3,
            ease: "power2.inOut"
          });
         $(this).attr("data-expanded",true)
        }
      // 控制同级展开状态
      let $siblingsitem = $(this).parent().siblings(".div-block-76").find(".div-block-77._65");
      let ispeo = $siblingsitem.attr("data-expanded");
      if(ispeo == "true"){
         gsap.to($siblingsitem.find(".div-block-120"), {
            height: 0,
            opacity: 0,
            display: "none",
            duration: 0.3,
            ease: "power2.inOut"
          });
        $siblingsitem.attr("data-expanded",false);
      }  
  })

  // 变体默认选中状态
     $(".div-block-77._65").each(function(){
      let $chlidbtn = $(this).find(".div-block-121 ");
      let $this =$(this);
      $chlidbtn.each(function(){
        if($(this).hasClass("checked")){
          let curttval = $(this).text();
          $this.find(".select-text").text(curttval);
        }
      })
    })

    // 分类页面排序
  Shopify.queryParams = {};

  // Preserve existing query parameters
  if (location.search.length) {
    var params = location.search.substr(1).split('&');

    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=');

      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      }
    }
  }

  // 监听排序
  $(".text-block-33").click(function(){
    let sortby = $(this).attr("data-sorby");
    Shopify.queryParams.sort_by = sortby;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  })


  const cart_add = (items) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post", //默认get
      url: window.Shopify.routes.root + 'cart/add.js', //默认当前页/
      data: {
        items
      },
      dataType: "json",
      success: function (response) { //请求成功回调
        resolve(response)
        let cartcount =  Number($(".cartcount").text());
        cartcount++;
        $(".cartcount").text(cartcount);
        
      },
      error: function (error) {
        reject(error)
      }
    })
  })
}

//调用
$('.product-form__buttons').click(async function () {
  const new_items = [
    {
      id: $(this).attr("data-variant"),
      quantity: 1
    }]
  await cart_add(new_items);
})

 

 
  